import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import CurseWithFilterTable from "components/CRPComponents/Tables/CoursesTable";
import DefaultCell from "components/CRPComponents/Tables/components/DefaultCell";
import LinkCell from "components/CRPComponents/Tables/components/LinkCell";
import { ListProps } from "./types";
import { GET_ALL_QUERY, GetAllGql } from "./queries/getAll";
import { ApiCourseWithSetData } from "data/queries/ApiCourse";
import ActiveOrInactiveCell from "components/CRPComponents/Tables/components/ActiveOrInactiveCell";
import { UseGetAllCourses } from "./hooks/UseGetAllCourses";
import { PublicViewButton } from "../../aplicacoes/publicView";

function List(props: ListProps) {
  const useGetAllCourses = UseGetAllCourses();

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <CurseWithFilterTable<GetAllGql>
        initialVariables={{
          page: 1,
          perPage: 10,
          search: null,
          status: "ACTIVE",
          filter: {},
        }}
        filter={true}
        useStatusString
        dowloadSvgJson={useGetAllCourses.responses}
        allFildsSvgh={useGetAllCourses.allFilds}
        path={`/ecommerce/cursos`}
        query={GET_ALL_QUERY}
        formatRows={(data) =>
          data.Courses.items.map((item) => ({
            ...item,
            categoryName: item.courseGroup.category.name,
            courseGroupName: item.courseGroup.name,
            modalityName: item.modality.name,
          }))
        }
        formatPagination={(data) => data.Courses.paginationInfo}
        title="NOVO CURSO"
        ApiSetData={ApiCourseWithSetData}
        columnsTable={[
          {
            Header: "id",
            accessor: "id",
            Cell: ({ value }: any) => (
              <LinkCell href={`/ecommerce/cursos/${value}`} value={value} />
            ),
          },
          {
            Header: "Nome",
            accessor: "name",
            Cell: ({ value }: any) => <DefaultCell value={value} />,
          },
          {
            Header: "Nível de ensino",
            accessor: "categoryName",
            Cell: ({ value }: any) => <DefaultCell value={value} />,
          },
          {
            Header: "Grupo de Curso",
            accessor: "courseGroupName",
            Cell: ({ value }: any) => <DefaultCell value={value} />,
          },
          {
            Header: "Modalidade",
            accessor: "modalityName",
            Cell: ({ value }: any) => <DefaultCell value={value} />,
          },
          {
            Header: "Ativo",
            accessor: "active",
            Cell: ({ value }: any) => <ActiveOrInactiveCell value={value} />,
          },
          {
            Header: "Ver",
            accessor: "preview",
            Cell: ({ row }: any) => (
              <PublicViewButton
                category="cursos"
                status={row.original.status}
                slug={row.original.slug}
                releaseDate={row.original.releaseDate}
              />
            ),
          },
        ]}
      />
      <Footer />
    </DashboardLayout>
  );
}

export default List;
